import { getStudioCertificateClaimUrl } from '../config/studio';
import type { MeProfileResponse } from '../services/builderProfileService';

export type PendingCertificateAction = {
  projectId: number;
  agentName: string;
  certificateAccess: boolean;
  title: string;
  description: string;
  ctaLabel: string;
  ctaUrl: string;
};

function certificateNudgeCopy(agentName: string, certificateAccess: boolean) {
  return {
    title: `You earned a certificate for building ${agentName}`,
    description: certificateAccess
      ? `Showcase it on your public portfolio and share your achievement on LinkedIn.`
      : `Showcase it on your public portfolio and share your achievement on LinkedIn. One-time $5 unlock.`,
  };
}

/** Complete agent builds with no minted certificate yet. */
export function derivePendingCertificateActions(
  profile: MeProfileResponse,
): PendingCertificateAction[] {
  const certProjectIds = new Set(profile.certificates.map((c) => c.project_id));

  return profile.agent_cards
    .filter((card) => card.status === 'complete' && !certProjectIds.has(card.project_id))
    .map((card) => {
      const copy = certificateNudgeCopy(card.name, profile.certificate_access);
      return {
        projectId: card.project_id,
        agentName: card.name,
        certificateAccess: profile.certificate_access,
        title: copy.title,
        description: copy.description,
        ctaLabel: 'Claim Now',
        ctaUrl: getStudioCertificateClaimUrl(card.project_id),
      };
    });
}
